module.exports = __webpack_public_path__ + "img/earth-country-line.9b649d42.png";